<div class="calendar-wrapper">
    <div class="gread-wrapper">
        <div class="grid">Weekday</div>
        <div class="grid black">00</div>
        <div class="grid black">01</div>
        <div class="grid black">02</div>
        <div class="grid black">03</div>
        <div class="grid black">04</div>
        <div class="grid black">05</div>
        <div class="grid black">06</div>
        <div class="grid black">07</div>
        <div class="grid black">08</div>
        <div class="grid black">09</div>
        <div class="grid black">10</div>
        <div class="grid black">11</div>
        <div class="grid black">12</div>
        <div class="grid black">13</div>
        <div class="grid black">14</div>
        <div class="grid black">15</div>
        <div class="grid black">16</div>
        <div class="grid black">17</div>
        <div class="grid black">18</div>
        <div class="grid black">19</div>
        <div class="grid black">20</div>
        <div class="grid black">21</div>
        <div class="grid black">22</div>
        <div class="grid black">23</div>
    </div>
    <div class="gread-wrapper" *ngFor="let weekday of weekdays">
        <div class="grid">{{weekday.WeekDay}}</div>
        <div class="grid" [style.background-color]="weekday.H0.color" ></div>
        <div class="grid" [style.background-color]="weekday.H1.color" ></div>
        <div class="grid" [style.background-color]="weekday.H2.color" ></div>
        <div class="grid" [style.background-color]="weekday.H3.color" ></div>
        <div class="grid" [style.background-color]="weekday.H4.color" ></div>
        <div class="grid" [style.background-color]="weekday.H5.color" ></div>
        <div class="grid" [style.background-color]="weekday.H6.color" ></div>
        <div class="grid" [style.background-color]="weekday.H7.color" ></div>
        <div class="grid" [style.background-color]="weekday.H8.color" ></div>
        <div class="grid" [style.background-color]="weekday.H9.color" ></div>
        <div class="grid" [style.background-color]="weekday.H10.color" ></div>
        <div class="grid" [style.background-color]="weekday.H11.color" ></div>
        <div class="grid" [style.background-color]="weekday.H12.color" ></div>
        <div class="grid" [style.background-color]="weekday.H13.color" ></div>
        <div class="grid" [style.background-color]="weekday.H14.color" ></div>
        <div class="grid" [style.background-color]="weekday.H15.color" ></div>
        <div class="grid" [style.background-color]="weekday.H16.color" ></div>
        <div class="grid" [style.background-color]="weekday.H17.color" ></div>
        <div class="grid" [style.background-color]="weekday.H18.color" ></div>
        <div class="grid" [style.background-color]="weekday.H19.color" ></div>
        <div class="grid" [style.background-color]="weekday.H20.color" ></div>
        <div class="grid" [style.background-color]="weekday.H21.color" ></div>
        <div class="grid" [style.background-color]="weekday.H22.color" ></div>
        <div class="grid" [style.background-color]="weekday.H23.color" ></div>
        
    </div>
   
</div>